import React from 'react';
import PropTypes from 'prop-types';

import { Link } from './styles';
import ArrowNext from '@spa/shared/svg/arrow-next';

const ArrowLink = ({ href, text, ...props }) => (
  <Link href={href} target="_blank" {...props}>
    <span>{text}</span>
    <ArrowNext />
  </Link>
);

ArrowLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default ArrowLink;
